/* unplugin-vue-components disabled */import script from "./mediaTypeTwo.vue?vue&type=script&lang=ts&setup=true"
export * from "./mediaTypeTwo.vue?vue&type=script&lang=ts&setup=true"

import "./mediaTypeTwo.vue?vue&type=style&index=0&id=497384ea&lang=scss&scoped=true"

import exportComponent from "E:\\code\\zd\\h5\\app_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497384ea"]])

export default __exports__